import { ShieldAlert } from 'lucide-react';

interface AccessDeniedScreenProps {
  title?: string;
  message?: string;
}

export default function AccessDeniedScreen({
  title = 'Access denied',
  message = 'You are not authorized to view this page. If you believe you should have access, please contact the responsible team.',
}: AccessDeniedScreenProps) {
  return (
    <div className="flex items-center justify-center min-h-[70vh] p-8">
      <div
        className="max-w-md w-full bg-white border border-zinc-200 p-8 text-center shadow-sm"
        style={{ borderRadius: '4px' }}
      >
        <div className="flex justify-center mb-4">
          <div
            className="w-14 h-14 bg-red-50 flex items-center justify-center"
            style={{ borderRadius: '4px' }}
          >
            <ShieldAlert className="w-7 h-7 text-red-500" />
          </div>
        </div>
        <h2 className="text-xl font-semibold text-zinc-900 mb-2">{title}</h2>
        <p className="text-sm text-zinc-500 mb-4">{message}</p>
      </div>
    </div>
  );
}
